/**
 * @generated SignedSource<<06d24198fd036c131c079e617725c7d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReportStatus = "DRAFT" | "ERROR" | "PENDING" | "PROCESSING" | "SUCCESS" | "%future added value";
export type ReportSubscriptionInput = {
  reportId: string;
};
export type ReportWatcherSubscription$variables = {
  input: ReportSubscriptionInput;
  resolutionSection?: string | null;
  anomalies?: ReadonlyArray<string | null> | null;
};
export type ReportWatcherSubscription$data = {
  readonly reportUpdated: {
    readonly event: string | null;
    readonly report: {
      readonly status: ReportStatus;
      readonly errors: any | null;
      readonly reviewStatus: string | null;
      readonly company: {
        readonly " $fragmentSpreads": FragmentRefs<"Integrations_company" | "IntegrationChoices_company">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"ReportsTableRow_report" | "ReportResolution_report" | "ReportResolutionTable_report">;
    } | null;
  } | null;
};
export type ReportWatcherSubscription = {
  variables: ReportWatcherSubscription$variables;
  response: ReportWatcherSubscription$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "anomalies"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resolutionSection"
},
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "event",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reviewStatus",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "config",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportWatcherSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ReportSubscriptionPayload",
        "kind": "LinkedField",
        "name": "reportUpdated",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Report",
            "kind": "LinkedField",
            "name": "report",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReportsTableRow_report"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReportResolution_report"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReportResolutionTable_report"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "Integrations_company"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "IntegrationChoices_company"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReportWatcherSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ReportSubscriptionPayload",
        "kind": "LinkedField",
        "name": "reportUpdated",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Report",
            "kind": "LinkedField",
            "name": "report",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deletedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": (v12/*: any*/),
                    "concreteType": "IntegrationsConnection",
                    "kind": "LinkedField",
                    "name": "integrations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IntegrationsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Integration",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v13/*: any*/),
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__typename",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "integrations(first:100)"
                  },
                  {
                    "alias": null,
                    "args": (v12/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "Integrations_integrations",
                    "kind": "LinkedHandle",
                    "name": "integrations"
                  },
                  {
                    "alias": null,
                    "args": (v12/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "IntegrationChoices_integrations",
                    "kind": "LinkedHandle",
                    "name": "integrations"
                  },
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slug",
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ReportUserFilesConnection",
                "kind": "LinkedField",
                "name": "reportUserFiles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReportUserFile",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserFile",
                        "kind": "LinkedField",
                        "name": "userFile",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "key",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReportIntegrationsConnection",
                "kind": "LinkedField",
                "name": "reportIntegrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReportIntegration",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Integration",
                        "kind": "LinkedField",
                        "name": "integration",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "pendingResolutions",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "condition",
                    "value": {
                      "updateStatus": "pending"
                    }
                  }
                ],
                "concreteType": "ReportResolutionsConnection",
                "kind": "LinkedField",
                "name": "reportResolutions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  }
                ],
                "storageKey": "reportResolutions(condition:{\"updateStatus\":\"pending\"})"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AnomalyCount",
                "kind": "LinkedField",
                "name": "anomalyCounts",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "anomalies",
                        "variableName": "anomalies"
                      },
                      {
                        "kind": "Variable",
                        "name": "status",
                        "variableName": "resolutionSection"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                  }
                ],
                "concreteType": "ReportResolutionsConnection",
                "kind": "LinkedField",
                "name": "filteredReportResolutions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReportResolution",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "anomalyTypes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "currentValue",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "updateStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "responseData",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "resolutionKind",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ccb56f3d1041542a31da7f38e8753ff1",
    "id": null,
    "metadata": {},
    "name": "ReportWatcherSubscription",
    "operationKind": "subscription",
    "text": "subscription ReportWatcherSubscription(\n  $input: ReportSubscriptionInput!\n  $resolutionSection: String\n  $anomalies: [String]\n) {\n  reportUpdated(input: $input) {\n    event\n    report {\n      status\n      errors\n      reviewStatus\n      ...ReportsTableRow_report\n      ...ReportResolution_report\n      ...ReportResolutionTable_report\n      company {\n        ...Integrations_company\n        ...IntegrationChoices_company\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment IntegrationChoices_company on Company {\n  id\n  rowId\n  integrations(first: 100) {\n    edges {\n      node {\n        id\n        rowId\n        kind\n        config\n        status\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  organization {\n    slug\n    id\n  }\n}\n\nfragment Integrations_company on Company {\n  integrations(first: 100) {\n    edges {\n      node {\n        id\n        rowId\n        kind\n        config\n        status\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ReportContextMenu_report on Report {\n  rowId\n  id\n  name\n  status\n  deletedAt\n  config\n  company {\n    id\n  }\n  reportUserFiles {\n    nodes {\n      type\n      userFile {\n        id\n        rowId\n        kind\n        name\n        key\n      }\n      id\n    }\n  }\n  reportIntegrations {\n    nodes {\n      integration {\n        id\n        owner {\n          id\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment ReportResolutionTable_report on Report {\n  filteredReportResolutions(input: {anomalies: $anomalies, status: $resolutionSection}) {\n    nodes {\n      id\n      anomalyTypes\n      currentValue\n      status\n      updateStatus\n      responseData\n      resolutionKind\n    }\n  }\n  id\n}\n\nfragment ReportResolution_report on Report {\n  id\n  reviewStatus\n  pendingResolutions: reportResolutions(condition: {updateStatus: \"pending\"}) {\n    totalCount\n  }\n  anomalyCounts {\n    type\n    count\n  }\n}\n\nfragment ReportSources_report on Report {\n  id\n  status\n  reportUserFiles {\n    nodes {\n      type\n      userFile {\n        id\n        rowId\n        kind\n        name\n        key\n      }\n      id\n    }\n  }\n}\n\nfragment ReportsTableRow_report on Report {\n  id\n  rowId\n  kind\n  name\n  status\n  createdAt\n  deletedAt\n  company {\n    id\n  }\n  ...ReportSources_report\n  ...ReportContextMenu_report\n}\n"
  }
};
})();

(node as any).hash = "6d149f578e8ffeb30de8390bbf35db0b";

export default node;
